// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectCustomListMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CUSTOM_LIST_MESSAGE)

    this.Id = -1;                       // 6
    this.Name = null;                   // 22
    this.Description = null;            // 28
    this.ListType = null;               // 828 - идентифицирует тип кастомного листа. Обрабатываем только CUSTOM_LIST_MESSAGE(494) в которых FIELD_LIST_TYPE[828] = 0 (thematic list).

    this.RawBytes = null;               // 304 - image
    this.TradableInstrumentId = null;   // 783 - список инструментов передается в таком же порядке как они были добавлены в БО.

    this.Aliases = null                 // 63  - languageAlias LANG = 642 Name = 22 DESCRIPTION = 28
};

DirectCustomListMessage.prototype = Object.create(DirectMessageBase.prototype)